import React, { useCallback, useEffect, useState } from "react";
import CardRowModule from "../../containers/PostCards/CardRowModule";
import Pagination from "../../containers/Pagination";
import SideADModule from "../../containers/PostCards/SideADModule";
import { getTopStoriesData } from "../../services/HomeServices";
import {
  formatDate,
  formatDateToMMYYYY,
} from "../../lib/constant";
import { toast } from "react-toastify";
import ReactDatePicker from "react-datepicker";
import _ from "lodash";
import Loader from "../../containers/Loader";
import { useNavigate } from "react-router-dom";

const MainSection = () => {
  const [topStoriesData, settopStoriesData] = useState([]);
  const [selectedMonth, setselectedMonth] = useState(new Date());
  const [search, setsearch] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const [page, setpage] = useState(1);
  const [links, setlinks] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    getTopStoryData();
  }, [page]);



  useEffect(() => {
    setpage(1);
    setTimeout(() => {
      getTopStoryData();
      
    }, 500);
  }, [search, selectedMonth]);

  const getTopStoryData = async () => {
    setisLoading(true);

    await getTopStoriesData(search, formatDateToMMYYYY(selectedMonth), page)
      .then((response) => {
        setisLoading(false);
        setlinks(response?.data?.data?.links);
        settopStoriesData(response?.data?.data?.data);
      })
      .catch((error) => {
        setisLoading(true);
        toast("Something went wrong", { type: "error" });
      });
  };

  return (
    <section
      className={`binduz-er-latest-news-area `}
      style={{ paddingTop: "30px" }}
    >
      <div className=" container">
        <div className="row">
          <div
            className=" col-lg-9"
            style={{ paddingRight: "40px", paddingLeft: "40px" }}
          >
            <div className="binduz-er-top-news-title">
              <h3 className="binduz-er-title">
                <i
                  className="far fa-newspaper"
                  style={{ color: "red", marginRight: "5px" }}
                ></i>
                TOP STORIES
              </h3>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                marginTop: "30px",
                marginBottom: "30px",
              }}
              className="col-lg-12"
            >
              <div className="row">
                <div className="col-lg-6">
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <ReactDatePicker
                      dateFormat="MMMM yyyy"
                      showMonthYearPicker
                      autoComplete="off"
                      placeholderText="Select Month & Year"
                      selected={selectedMonth}
                      onChange={(e) => setselectedMonth(e)}
                      name="date"
                      className="form-control"
                      style={{
                        width: "100%",
                        paddingRight: "35px", // Space for emoji
                        paddingLeft: "12px",
                        height: "40px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        fontSize: "16px",
                      }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        fontSize: "18px",
                      }}
                    >
                      <i className="far fa-calendar" />
                    </span>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="binduz-er-author-sidebar-search-bar col-lg-4">
                    <form
                      onSubmit={(e) => {
                        e?.preventDefault();
                        getTopStoryData();
                      }}
                    >
                      <div
                        className="binduz-er-input-box"
                        style={{ width: "270px" }}
                      >
                        <input
                          type="text"
                          onChange={(e) => setsearch(e?.target?.value)}
                          value={search}
                          placeholder="Search from here..."
                          style={{ lineHeight: "38px" }}
                        />
                        <button type="submit" style={{ height: "40px" }}>
                          <i className="fal fa-search"></i>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            {!isLoading ? (
              <>
                {!_.isEmpty(topStoriesData) ? (
                  <>
                    {topStoriesData?.map((item, index) => (
                      <CardRowModule
                        key={item.id}
                        datas={{
                          data: item,
                          image: item?.image,
                          category: item?.title,
                          index: index,
                          isTopStories: true,
                          imageSize: "145px",
                          title: item?.content,
                          pathname: `/details/${item?.id}`,
                          onClickFun: () => {
                            navigate(`/details/${item?.id}`, {
                              state: item,
                            });
                          },
                          date: formatDate(item?.date),
                        }}
                      />
                    ))}
                    <Pagination links={links} setpage={setpage} />
                  </>
                ) : (
                  <h5 style={{ textAlign: "center" }}>No Data Found</h5>
                )}
              </>
            ) : (
              <div style={{ marginTop: "80px" }}>
                <Loader />
              </div>
            )}
          </div>
          <div
            className=" col-lg-3"
            // style={{ paddingRight: "85px", paddingLeft: "55px" }}
          >
            {/* <div className="binduz-er-top-news-title">
              <h3 className="binduz-er-title">EXPLORE YOUR COUNTRY</h3>
            </div>
            <div className="binduz-er-footer-gallery ">
              <div className="binduz-er-footer-gallery-widget d-flex">
                {[1, 1]?.map(() => (
                  <div className="">
                    <a href="#">
                      <img
                        height={85}
                        src={
                          require(`../../assets/images/classifield.png`).default
                        }
                        alt=""
                      />
                    </a>
                  </div>
                ))}
              </div>
              <div className="binduz-er-footer-gallery-widget d-flex">
                {[1, 1]?.map(() => (
                  <div className="">
                    <a href="#">
                      <img
                        height={85}
                        src={
                          require(`../../assets/images/classifield.png`).default
                        }
                        alt=""
                      />
                    </a>
                  </div>
                ))}
              </div>
              <div className="binduz-er-footer-gallery-widget d-flex">
                {[1, 1]?.map(() => (
                  <div className="">
                    <a href="#">
                      <img
                        height={85}
                        src={
                          require(`../../assets/images/classifield.png`).default
                        }
                        alt=""
                      />
                    </a>
                  </div>
                ))}
              </div>
            </div>

            <div
              className="binduz-er-footer-gallery "
              style={{ marginTop: "77px" }}
            >
              <div className="binduz-er-footer-gallery-widget d-flex">
                {[1, 1]?.map(() => (
                  <div className="binduz-er-item">
                    <a href="#">
                      <img
                        height={155}
                        width={165}
                        src={
                          require(`../../assets/images/classifield.png`).default
                        }
                        alt=""
                      />
                    </a>
                  </div>
                ))}
              </div>
              <div className="binduz-er-footer-gallery-widget d-flex">
                {[1, 1]?.map(() => (
                  <div className="binduz-er-item">
                    <a href="#">
                      <img
                        height={155}
                        width={165}
                        src={
                          require(`../../assets/images/classifield.png`).default
                        }
                        alt=""
                      />
                    </a>
                  </div>
                ))}
              </div>
            </div> */}
            <SideADModule isClassifield={true} isEvent={true} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainSection;
